package com.milta.feature.route.data.remote.dto

import com.milta.feature.route.domain.entity.Route
import com.milta.feature.route.domain.entity.RouteStatus
import kotlinx.serialization.Serializable

/** Mirrors backend `RouteDetailDto` (MIL-38 — `GET /api/v1/routes/{id}`). */
@Serializable
data class RouteDto(
    val id: String,
    val date: String,
    val status: String,
    val driverFirstName: String,
    val driverLastName: String,
    val startedAt: String? = null,
    val deliveries: List<DeliveryDto> = emptyList(),
)

fun RouteDto.toDomain() = Route(
    id = id,
    date = date,
    status = when (status) {
        "InProgress" -> RouteStatus.InProgress
        "Completed"  -> RouteStatus.Completed
        else         -> RouteStatus.Scheduled
    },
    driverFirstName = driverFirstName,
    driverLastName = driverLastName,
    startedAt = startedAt,
    // Defensive re-sort: the API already orders by SortOrder, but the UI relies on this order.
    deliveries = deliveries.sortedBy { it.sortOrder }.map { it.toDomain() },
)
